import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'account',
  label: 'Account Section',
  description: 'User dashboard with orders, addresses, and profile settings.',
  supportedPages: ['account'],
  variants: [
    { id: 'v1', label: 'V1 (Sidebar + Content)' },
    { id: 'v2', label: 'Order History' },
    { id: 'v3', label: 'Address Book' },
  ],
  commonFields: [
    { key: 'tabOverviewLabel', label: 'Overview Tab Label', type: 'string', default: 'Overview' },
    { key: 'tabOrdersLabel', label: 'Orders Tab Label', type: 'string', default: 'Orders' },
    { key: 'tabAddressesLabel', label: 'Addresses Tab Label', type: 'string', default: 'Addresses' },
    { key: 'tabDetailsLabel', label: 'Profile Tab Label', type: 'string', default: 'Profile' },
    { key: 'signOutLabel', label: 'Sign Out Label', type: 'string', default: 'Sign Out' },
    { key: 'signinRedirectPath', label: 'Sign In Redirect Path', type: 'string', default: '/signin' },
  ],
}
